import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserOceanCleanupGame from 'src/games/OceanCleanupGame/Main';

interface OceanCleanupGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class OceanCleanupGame extends React.Component<OceanCleanupGameProps> {
    constructor(props: OceanCleanupGameProps) {
        super(props);
        bindAllOfThis(this, OceanCleanupGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserOceanCleanupGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default OceanCleanupGame;



// WEBPACK FOOTER //
// ./src/pages/game/OceanCleanupGame.tsx